import * as React from 'react';
import CollapsiblePanel from '../../../components/CollapsiblePanel/CollapsiblePanel';
import ScriptsPanel from '../ScriptsPanel/ScriptsPanel';
import ScriptsPanelMini from '../ScriptsPanelMini/ScriptsPanelMini';
import { Environment } from '../../../../const/environment';

type ScriptsPanelContainerProps = {
    projectName: string,
    scriptName: string,
    environment: Environment,
    searchTerm: string,
    onPanelCollapsed: () => void;
    onPanelExpanded: () => void;
    onCloseSearch: () => void;
}

export function ScriptsPanelContainer({
    projectName,
    scriptName,
    environment,
    searchTerm,
    onPanelCollapsed,
    onPanelExpanded,
    onCloseSearch
}: ScriptsPanelContainerProps) {
    return (
        <CollapsiblePanel
            title="Scripts"
            id="scripts"
            direction="left"
            onPanelCollapsed={onPanelCollapsed}
            onPanelExpanded={onPanelExpanded}
            actionPanel={
                <ScriptsPanelMini
                    projectName={projectName}
                    environment={environment}
                />
            }>
            <ScriptsPanel
                searchTerm={searchTerm}
                projectName={projectName}
                scriptName={scriptName}
                environment={environment}
                canImportScripts={true}
                canExportScripts={true}
                onCloseSearch={onCloseSearch}
            />
        </CollapsiblePanel>
    );
}

